import { Component } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { FinoCommonModule } from '@fino-ui/common';
import { BaseModalComponent } from '@fino-ui/modal';
import { FinoTranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-submit-modal',
  templateUrl: './submit-modal.component.html',
  imports: [FinoTranslationModule, ButtonModule, FinoCommonModule],
})
export class SubmitModalComponent extends BaseModalComponent<any, any> {
  submit() {
    this.result = true;
    this.close();
  }
}
